import { ERROR_TYPES, GENERIC_ERROR_MESSAGE } from "@ds-developer/constants";

const getErrorMessage = (errorType: string) => {
  switch (errorType) {
    case ERROR_TYPES.CANCELLATION_REASON_TOO_SHORT:
      return "Please enter a cancellation reason with at least 5 words";
    case ERROR_TYPES.LESSON_IN_PAST:
      return "You cannot cancel that lesson as it has already taken place";
    default:
      return GENERIC_ERROR_MESSAGE;
  }
};

export default getErrorMessage;
